import { ReportStatus, SortCriteria, SortCriteriaField, SortOrder } from "@amzn/coral_com-amazon-transreportscenterservice";
import { getTimeZone } from "../utils/dateUtils";
import invert from "lodash/invert";
import { REPORTS_LIST_PATH } from "./routes";
export var DEFAULT_SORT_CRITERIA = SortCriteria.clone({
    sortField: SortCriteriaField.LAST_UPDATED_TIME,
    sortOrder: SortOrder.DESC
});
export var TABLE_SORT_DIRECTION_SORT_ORDER_MAP = {
    ascending: SortOrder.ASC,
    descending: SortOrder.DESC
};
export var INVERTED_TABLE_SORT_DIRECTION_SORT_ORDER_MAP = invert(TABLE_SORT_DIRECTION_SORT_ORDER_MAP);
export var TABLE_SORT_COLUMN_SORT_ORDER_MAP = {
    lastUpdatedTime: SortCriteriaField.LAST_UPDATED_TIME,
    reportRecordLastUpdatedTime: SortCriteriaField.REPORT_RECORD_LAST_UPDATED_TIME,
    recordCreationTime: SortCriteriaField.REPORT_RECORD_CREATION_TIME
};
export var INVERTED_TABLE_SORT_COLUMN_SORT_ORDER_MAP = invert(TABLE_SORT_COLUMN_SORT_ORDER_MAP);
export var TABLE_COLUMNS_TYPE_TIME = [
    "lastUpdatedTime",
    "creationTime"
];
export var TABLE_COLUMNS_TYPE_STATUS = [
    "reportStatus"
];
export var TABLE_COLUMNS_SORATABLE = [
    "lastUpdatedTime"
];
export var TABLE_COLUMN_TYPE_TIME_HEADER_SUFFIX = " (".concat(getTimeZone(), ")");
// Default columns as fallback
export var TABLE_COLUMNS = [
    {
        columnDisplayName: "reports_list_page.report_name",
        valuePathStructure: "reportName"
    },
    {
        columnDisplayName: "reports_list_page.published_on",
        valuePathStructure: "lastUpdatedTime"
    }
];
export var LP_DROPDOWN_ALLOWED_PATHS = [
    REPORTS_LIST_PATH
];
export var REPORT_STATUSES = Object.keys(ReportStatus).filter(function(status) {
    return ![
        ReportStatus.PENDING,
        ReportStatus.PUBLISHED,
        ReportStatus.INGESTION_PENDING,
        ReportStatus.APPROVAL_CREATED
    ].includes(status);
});

//# sourceMappingURL=search.js.map